import script from "./ChatMessageReactionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageReactionsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageReactionsModal.vue?vue&type=style&index=0&id=6c1679f4&lang=scss"

const __exports__ = script;

export default __exports__